<template>
  <router-view v-if="isRouterAlive" />
</template>

<script setup>
import { ref, provide, nextTick } from 'vue'

const isRouterAlive = ref(true)

const reload = () => {
  isRouterAlive.value = false
  nextTick(() => {
    isRouterAlive.value = true
  })
}

provide('reload', reload)
</script>

<style>
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css";
</style>
